<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroHotel from "./../Components/Cadastros/CadastroHotel.vue";
export default {
  name: "RegisterHotel",
  components: {
    CadastroHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
